import Grid from "@mui/material/Grid";
import { OverviewCard } from "../shared/components/OverviewCard";
import { useNavigate } from "react-router-dom";
import { PageContainer } from "../shared/components/PageContainer";
import { useEffect, useState } from "react";
import { useFetchContext } from "../../contexts/FetchContext";
import { useOrderContext } from "../../contexts/OrderContext";
import { useAuthContext } from "../../contexts/AuthContext";
import { IDataPagination } from "../../interfaces";
import {
  DocumentsData,
  DocumentStatus,
  WarehouseLocation,
} from "../../interfaces/document";

export const Verify = () => {
  const navigate = useNavigate();

  const { fetchData } = useFetchContext();
  const { userData } = useAuthContext();

  const [contatore, setContantore] = useState<number>(0);
  const [ubicazioni, setUbicazioni] = useState<number>(0);
  const [movimentazioni, setMovimentazioni] = useState<number>(0);
  const orders = useOrderContext();

  useEffect(() => {
    const fetchDataAsync = async () => {
      try {
        const response = await fetchData(
          `/products/inventory-check?page=1&&orderType=DESC&orderBy=quantity`
        );

        setContantore(response?.data?.info?.totalStocks);

        const responseUb = await fetchData<IDataPagination<WarehouseLocation>>(
          `/warehouse-locations?warehouseId=${userData?.user?.warehouseId}&pageSize=1&page=1`
        );
        setUbicazioni(responseUb?.data?.total);

        const currentYear = new Date().getFullYear();
        const startDate = new Date(currentYear, 0, 1).toISOString();

        const responseMv = await fetchData<IDataPagination<DocumentsData>>(
          `/documents?status=${DocumentStatus.CLOSED}&page=1&pageSize=1&startUpdatedAt=${startDate}`
        );

        setMovimentazioni(responseMv?.data?.total);
      } catch (error) {}
    };

    fetchDataAsync();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orders]);

  return (
    <PageContainer>
      <Grid item xs={12} mb={4}>
        <OverviewCard
          sx={{ height: "100%", cursor: "pointer" }}
          value={contatore}
          title="PRODOTTI"
          backgroundIcon="red"
          onClick={() => navigate("/verify/products")}
        />
      </Grid>
      <Grid item xs={12} mb={4}>
        <OverviewCard
          sx={{ height: "100%", cursor: "pointer" }}
          value={contatore}
          title="MATRICOLE"
          backgroundIcon="#8BC34A"
          onClick={() => navigate("/verify/serialNumbers")}
        />
      </Grid>
      {userData?.user?.warehouse?.hasWarehouseLocations && (
        <>
          <Grid item xs={12} mb={4}>
            <OverviewCard
              sx={{ height: "100%", cursor: "pointer" }}
              value={contatore}
              title="INVENTARIO"
              backgroundIcon="lightblue"
              onClick={() => navigate("/verify/inventory")}
            />
          </Grid>
          <Grid item xs={12} mb={4}>
            <OverviewCard
              sx={{ height: "100%", cursor: "pointer" }}
              title="Ubicazioni"
              value={ubicazioni}
              backgroundIcon="orange"
              onClick={() => navigate("/verify/locations")}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12} mb={4}>
        <OverviewCard
          sx={{ height: "100%", cursor: "pointer" }}
          title="Registro Movimenti"
          value={movimentazioni}
          backgroundIcon="black"
          onClick={() => navigate("/verify/movement-log")}
        />
      </Grid>

      <Grid item xs={12} mb={4}>
        <OverviewCard
          sx={{ height: "100%", cursor: "pointer" }}
          title="Report Royalty"
          backgroundIcon="red"
          onClick={() => navigate("/verify/royalty")}
        />
      </Grid>
    </PageContainer>
  );
};
